/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sign_InInputs */

const th_sign_in = /** @type {(inputs: Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เข้าสู่ระบบ`)
};

const en_sign_in = /** @type {(inputs: Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in`)
};

const ja_sign_in = /** @type {(inputs: Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ログイン`)
};

const zh_sign_in = /** @type {(inputs: Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登录`)
};

const es_sign_in = /** @type {(inputs: Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciar sesión`)
};

const pt_sign_in = /** @type {(inputs: Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrar`)
};

const id_sign_in = /** @type {(inputs: Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masuk`)
};

const fr_sign_in = /** @type {(inputs: Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se connecter`)
};

const tl_sign_in = /** @type {(inputs: Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mag-sign in`)
};

const vi_sign_in = /** @type {(inputs: Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đăng nhập`)
};

const ko_sign_in = /** @type {(inputs: Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`로그인`)
};

const de_sign_in = /** @type {(inputs: Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anmelden`)
};

const ru_sign_in = /** @type {(inputs: Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Войти`)
};

const tr_sign_in = /** @type {(inputs: Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giriş yap`)
};

const it_sign_in = /** @type {(inputs: Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accedi`)
};

const pl_sign_in = /** @type {(inputs: Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zaloguj się`)
};

const uk_sign_in = /** @type {(inputs: Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Увійти`)
};

const hi_sign_in = /** @type {(inputs: Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`साइन इन करें`)
};

const ar_sign_in = /** @type {(inputs: Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تسجيل الدخول`)
};

const ms_sign_in = /** @type {(inputs: Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log masuk`)
};

const bn_sign_in = /** @type {(inputs: Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সাইন ইন`)
};

const zh_tw2_sign_in = /** @type {(inputs: Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登入`)
};

const zh_hk2_sign_in = /** @type {(inputs: Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登入`)
};

const ur_sign_in = /** @type {(inputs: Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سائن اِن`)
};

const fa_sign_in = /** @type {(inputs: Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ورود`)
};

const sw_sign_in = /** @type {(inputs: Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingia`)
};

const nl_sign_in = /** @type {(inputs: Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inloggen`)
};

/**
* | output |
* | --- |
* | "Sign in" |
*
* @param {Sign_InInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const sign_in = /** @type {((inputs?: Sign_InInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sign_InInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_sign_in(inputs)
	if (locale === "ja") return ja_sign_in(inputs)
	if (locale === "zh") return zh_sign_in(inputs)
	if (locale === "es") return es_sign_in(inputs)
	if (locale === "pt") return pt_sign_in(inputs)
	if (locale === "id") return id_sign_in(inputs)
	if (locale === "fr") return fr_sign_in(inputs)
	if (locale === "tl") return tl_sign_in(inputs)
	if (locale === "vi") return vi_sign_in(inputs)
	if (locale === "ko") return ko_sign_in(inputs)
	if (locale === "de") return de_sign_in(inputs)
	if (locale === "ru") return ru_sign_in(inputs)
	if (locale === "tr") return tr_sign_in(inputs)
	if (locale === "it") return it_sign_in(inputs)
	if (locale === "pl") return pl_sign_in(inputs)
	if (locale === "uk") return uk_sign_in(inputs)
	if (locale === "hi") return hi_sign_in(inputs)
	if (locale === "ar") return ar_sign_in(inputs)
	if (locale === "ms") return ms_sign_in(inputs)
	if (locale === "bn") return bn_sign_in(inputs)
	if (locale === "zh-TW") return zh_tw2_sign_in(inputs)
	if (locale === "zh-HK") return zh_hk2_sign_in(inputs)
	if (locale === "ur") return ur_sign_in(inputs)
	if (locale === "fa") return fa_sign_in(inputs)
	if (locale === "sw") return sw_sign_in(inputs)
	if (locale === "nl") return nl_sign_in(inputs)
	return en_sign_in(inputs)
});